// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';

import Login from './pages/Login';
import Files from './pages/Files';
import Sidebar from './components/Sidebar';
import GalleryPage from './pages/GalleryPage';
import PlaylistsPage from './pages/PlaylistsPage';
import DetailPlaylistPage from './pages/DetailPlaylistPage';
import CompaniesPage from './pages/CompaniesPage';
import CompanyDetailPage from './pages/CompanyDetailPage';
import AnalyticsPage from './pages/AnalyticsPage';

// Аудио
import AudioFilesPage from './pages/AudioFilesPage';
import AudioPlaylistList from './pages/AudioPlaylistList';
import AudioPlaylistDetail from './pages/AudioPlaylistDetail';

// Новый раздел: аудио по устройствам (аудио-центричное управление)
import AudioByDevicesList from './pages/AudioByDevicesList';
import AudioByDevicesDetail from './pages/AudioByDevicesDetail';

// Партнёрская страница загрузки по hash
// следи за регистром папки: Partners vs partners
import UploadPage from './pages/partners/UploadPage';
import AdvertisersPage from "./pages/advertisers/AdvertisersPage";
import AdvertisersSimplePage from "./pages/advertisers/AdvertisersSimplePage";

// Новые страницы: рекламные кампании и точки
import AdCampaignsPage from './pages/AdCampaignsPage';
import AdCampaignLocationsPage from './pages/AdCampaignLocationsPage';

function Layout() {
    const location = useLocation();
    const isLoginPage = location.pathname === '/login';
    const isPartnerPage = location.pathname.startsWith('/partners/');
    const isAdvertisers = location.pathname.startsWith('/advertisers/');
    const isAdvert = location.pathname.startsWith('/advert/');
    const hideSidebar = isLoginPage || isPartnerPage || isAdvertisers || isAdvert;

    const routes = (
        <Routes>
            <Route path="/login" element={<Login />} />

            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <AnalyticsPage />
                    </ProtectedRoute>
                }
            />

            {/* Видео плейлисты */}
            <Route
                path="/playlists"
                element={
                    <ProtectedRoute>
                        <PlaylistsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/playlists/detail/:playlistId"
                element={
                    <ProtectedRoute>
                        <DetailPlaylistPage />
                    </ProtectedRoute>
                }
            />

            {/* Файлы (видео/изображения) */}
            <Route
                path="/files"
                element={
                    <ProtectedRoute>
                        <GalleryPage />
                    </ProtectedRoute>
                }
            />

            {/* Аналитика */}
            <Route
                path="/analytics"
                element={
                    <ProtectedRoute>
                        <AnalyticsPage />
                    </ProtectedRoute>
                }
            />

            {/* Компании */}
            <Route
                path="/companies"
                element={
                    <ProtectedRoute>
                        <CompaniesPage />
                    </ProtectedRoute>
                }
            />
            <Route path="/companies/:id" element={<CompanyDetailPage />} />

            {/* --- Аудио --- */}
            <Route
                path="/audio-files"
                element={
                    <ProtectedRoute>
                        <AudioFilesPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/audio-playlists"
                element={
                    <ProtectedRoute>
                        <AudioPlaylistList />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/audio-playlists/:id"
                element={
                    <ProtectedRoute>
                        <AudioPlaylistDetail />
                    </ProtectedRoute>
                }
            />

            {/* --- Аудио по устройствам (новые страницы) --- */}
            <Route
                path="/audio-devices"
                element={
                    <ProtectedRoute>
                        <AudioByDevicesList />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/audio-devices/:id"
                element={
                    <ProtectedRoute>
                        <AudioByDevicesDetail />
                    </ProtectedRoute>
                }
            />

            {/* --- Рекламные кампании (видео-реклама) --- */}
            <Route
                path="/ad-campaigns"
                element={
                    <ProtectedRoute>
                        <AdCampaignsPage />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/ad-campaigns/:id/locations"
                element={
                    <ProtectedRoute>
                        <AdCampaignLocationsPage />
                    </ProtectedRoute>
                }
            />

            {/* --- Партнёрская загрузка по hash, публичная страница --- */}
            <Route path="/partners/:hash" element={<UploadPage />} />
            <Route path="/advertisers/:hash" element={<AdvertisersPage />} />
            <Route path="/advert/:hash" element={<AdvertisersSimplePage />} />
        </Routes>
    );

    return (
        <>
            {!hideSidebar && <Sidebar />}

            {isPartnerPage ? (
                // партнёрская страница — без .main-content,
                // занимает всю ширину root/body
                routes
            ) : (
                // для остальных страниц остаётся старый контейнер
                <div
                    className="main-content"
                    style={hideSidebar ? { marginLeft: 0 } : {}}
                >
                    {routes}
                </div>
            )}
        </>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Layout />
            </BrowserRouter>
        </AuthProvider>
    );
}
